import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Projects from "./pages/Projects";
import { useRef } from "react";
import DetailProject from "./pages/DetailProject";
import { useState } from "react";
import CustModal from "./components/CustModal";
import NotFoundPage from "./pages/NotFound";

const App = () => {
  const toWelcoming = useRef(null);
  const toOurProjects = useRef(null);
  const toOurServices = useRef(null);
  const toContact = useRef(null);
  const [show, setShow] = useState(true);

  const moveTo = [toWelcoming, toOurProjects, toOurServices, toContact];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Router>
        <CustModal show={show} />
        <Navbar moveTo={moveTo} />
        <Routes>
          <Route
            path="/"
            element={<LandingPage moveTo={moveTo} handleClose={handleClose} handleShow={handleShow} />}
          />
          <Route path="/project" element={<Projects handleClose={handleClose} handleShow={handleShow} />} />
          <Route path="/project/:id" element={<DetailProject handleClose={handleClose} handleShow={handleShow} />} />
          <Route path="*" element={<NotFoundPage handleClose={handleClose} />} />
        </Routes>
        { !show && <Footer moveTo={toContact} handleClose={handleClose} />}
      </Router>
    </>
  );
};

export default App;
